import { ButtonAPI, FieldAPI, FormAPI, InputAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnChange, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import ResetPasswordService from '../../services/reset-password-service';
import BaseController from '../BaseController';
import { CONFIRMATION_FIELD_VALID, confirmationFieldValidator, CRYPTOPW_VALIDATOR, CRYPTOPW_VALIDATOR_DEPRECATED, cryptoPWValidator, cryptoPWValidatorDeprecated, NEW_CRYPTOPW_VALIDATOR, newCryptoPWValidatorValidator } from '../../utils/user-util';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { AuthenticationService, HttpResponse, JWTToken } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import pollingService from '../../services/polling/polling-service';
import TokenConstants from '../../constants/TokenConstants';
import { ToastResponse } from '../../interfaces/ToastResponse';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { showToastNotificationMessage } from '../../utils/toast-notification-utils';
import { HttpServiceError, HttpServiceResponse, PatientHttpService } from '../../services/patient-http-service';

@Controller({ component: 'root-modal', fragment: 'change-password' })
class ChangePasswordController extends BaseController {

  @Inject('old-password-field')
    fieldActualPassword!: FieldAPI;

  @Inject('new-password-field')
    fieldNewPassword!: FieldAPI;

  @Inject('confirm-password-field')
    fieldNewConfirmPassword!: FieldAPI;

  @Inject('reset-form')
    formPassword!: FormAPI;

  @Inject('email-input')
    emailInput!: InputAPI;

  @Inject('ResetPasswordService')
    ResetPasswordService!: ResetPasswordService;

  @Inject('password-submit-button')
    confirmBtn!: ButtonAPI;

  @Inject('email-field')
    emailField!: FieldAPI;

  alteracaoCompleta = false;

  @OnMount({ target: ['root-modal'] })
  onMountModalAltSenha(): void {
    this.fieldActualPassword.addLocalValidator(CRYPTOPW_VALIDATOR_DEPRECATED, cryptoPWValidatorDeprecated);
    this.fieldNewPassword.addLocalValidator(CRYPTOPW_VALIDATOR, cryptoPWValidator);
    this.fieldNewConfirmPassword.addLocalValidator(CONFIRMATION_FIELD_VALID, (value) => {
      const confirmationValue = this.formPassword.getRecord()['newPassword'] || '';
      return confirmationFieldValidator(value, confirmationValue);
    });
    this.fieldNewPassword.addLocalValidator(NEW_CRYPTOPW_VALIDATOR, (value) => {
      const senhaAtual = this.formPassword.getRecord()['password'] || '';
      return newCryptoPWValidatorValidator(value, senhaAtual);
    });
    this.confirmBtn.setEnabled(false);
  }

  @OnChange({ target: ['reset-form'] })
  onChangeFormAltSenha({ value }: ChangeEvent<Record<string, Value>>): void {
    this.confirmBtn.setEnabled(this.isDataValid(value));
  }

  isDataValid(value: Record<string, Value>): boolean {
    return this.fieldNewPassword.isValid() &&
      this.fieldActualPassword.isValid() &&
      this.fieldNewConfirmPassword.isValid() &&
      Boolean(value['password']) &&
      Boolean(value['newPassword']) &&
      Boolean(value['confirmPassword']) &&
      (value['newPassword'] === value['confirmPassword']);
  }

  @OnClick({ target: ['password-submit-button'] })
  onClickAltSenha(): void {
    this.confirmBtn.setEnabled(false);
    this.formPassword.setEditing(false);
    if(this.isLogin()){
      this.alterPassword()
    } else{
      this.renewPassword();
    }
  }

  alterPassword(): void {
    const body = this.formPassword.getRecord();
    PatientHttpService.post(APPLICATION_ENDPOINTS.POST_ALTER_PASSWORD, {}, { body })
      .then(resp => {
        this.handleSuccess(resp);
      }).catch(({ response }: HttpServiceError<ToastResponse>) => {
        this.handleFailure(response);
      });
  }

  renewPassword(): void {
    const body = this.formPassword.getRecord();
    body.login = this.context.get('username');
    PatientHttpService.post(APPLICATION_ENDPOINTS.POST_RENEW_PASSWORD, {}, { body }).then(resp => {
      this.handleSuccess(resp);
    }).catch(({ response }: HttpServiceError<ToastResponse>) => {
      this.handleFailure(response);
    });
  }

  handleSuccess(resp: HttpResponse<unknown>): void {
    this.handleResponse(resp);
  }

  handleResponse(resp: HttpResponse<unknown>): void {
    this.alteracaoCompleta = true;
    showToastNotificationMessage(resp.body as ToastResponse);
    this.closeModalTimer();
  }
  closeModalTimer(): void {
    pollingService.createPolling('close-modal-renew-password', this.closeChangePasswordModal, 5000);
  }

  closeChangePasswordModal = ():void => {
    if (this.isLogin()) {
      const token = AuthenticationService.getJWTToken() as JWTToken;
      const patientId: string = token.claims[TokenConstants.PATIENT_ID] as string;
      const params = { patientId };
      this.historyService.push(APPLICATION_ROUTES.PROFILE, params);
    } else {
      this.historyService.push(APPLICATION_ROUTES.LOGIN);
    }
    pollingService.removePolling('close-modal-renew-password');
  }

  isLogin(): boolean {
    return !this.historyService.getCurrentRoute().includes(APPLICATION_ROUTES.LOGIN) && this.changePassword();
  }

  changePassword(): boolean {
    const token = AuthenticationService.getJWTToken();
    if (token == null) {
      return false;
    }
    return token.claims[TokenConstants.PATIENT_ID] as boolean;
  }

  handleFailure(resp?: HttpServiceResponse<ToastResponse>): void {
    this.formPassword.setEditing(true);
    this.confirmBtn.setEnabled(this.isDataValid(this.formPassword.getRecord()));

    if (resp) {
      showToastNotificationMessage(resp.body);
    }
  }

  @OnClose({ target: 'root-modal' })
  onRootModalClose(): void {
    if(this.isLogin()){
      const token = AuthenticationService.getJWTToken() as JWTToken;
      const patientId: string = token.claims[TokenConstants.PATIENT_ID] as string;
      const params = { patientId };
      this.historyService.push(APPLICATION_ROUTES.PROFILE, params);
    }
    else {
      this.historyService.push(APPLICATION_ROUTES.LOGIN);
    }
  }
}

export default ChangePasswordController;
